/**
 * Newsletter-gebundenes Gratisprodukt
 * -----------------------------------
 * Legt das Gratis-Produkt in den Warenkorb, sobald
 *   (a) der Kunde ueber den Newsletter-Link kam  (?nl_gift=1)
 *   (b) der qualifizierende Warenkorbwert >= THRESHOLD_CENTS ist.
 *
 * Eingelegt wird das ECHTE Produkt (11,50 EUR). Gratis wird es durch den
 * Rabattcode RIESLING49 (Produktrabatt "Kaufe ab 49 EUR, erhalte 1x gratis"),
 * den das Skript mit anwendet. Das Skript legt also Position UND Code rein bzw.
 * raus.
 *
 * Code anwenden ohne Reload und ohne NEWS10 zu verlieren:
 *   fetch('/discount/RIESLING49') laeuft auf einen 302, der
 *   "Set-Cookie: discount_code=..." mitschickt. Bei einem Same-Origin-Fetch mit
 *   credentials uebernimmt der Browser das Cookie, ohne zu navigieren.
 *
 *   Reihenfolge ist wichtig: erst den Code setzen, dann die Flasche hinzufuegen.
 *   Shopify wertet die Rabatte beim Warenkorb-Schreibzugriff aus, die Antwort von
 *   cart/add.js enthaelt das Ergebnis also schon. Umgekehrt (erst Flasche, dann
 *   Code) braeuchte es einen zweiten Roundtrip und man haengt an Timing.
 *
 *   Es gibt bewusst KEINEN Reload-Fallback: ein sichtbarer Seitenwechsel mitten
 *   im Einkauf ist ein UX-Bruch. Greift der Rabatt nicht, wird die Flasche
 *   wieder entfernt und das Feature stillgelegt - der Kunde bekommt nie eine
 *   bezahlte Flasche untergeschoben, die er nicht bestellt hat.
 *
 * Anbindung an das Theme (bewusst keine eigenen Cart-Mechanismen):
 *   - liest den Warenkorb aus dem Payload von 'cart:updated' bzw. via
 *     theme.cart.getCart()
 *   - schreibt ueber theme.routes.cartAdd und theme.cart.changeItem()
 *   - loest das Neu-Rendern mit 'cart:build' aus. Darauf hoert jede CartForm,
 *     also Drawer und Warenkorbseite gleichzeitig. cartMarkup() aktualisiert
 *     dabei Positionen, Anzahl, Zwischensumme, Rabatte und Mengen-Widgets.
 *   - 'cart:build' statt 'ajaxProduct:added', weil letzteres den Drawer
 *     zusaetzlich aufklappt. Das soll nur passieren, wenn der Kunde selbst
 *     etwas hinzufuegt, nicht beim automatischen Gratisprodukt.
 *
 * Bekannte Grenze: laeuft nur im Shop, nicht im Checkout. Eine Absicherung
 * dort waere eine eigene Shopify Function.
 */
(function () {
  'use strict';

  // --- Konstanten ----------------------------------------------------------

  // Dediziertes, verstecktes Geschenkprodukt
  // "Gratis Geschenk ab 49 EUR (Newsletter): RIESLING trocken"
  // Produkt 16570372456716, Tag nl_gift_product.
  //
  // Bewusst eine EIGENE Variante, nicht das regulaer verkaufte RIESLING trocken
  // (54639125037324). Das loest zwei Dinge auf einmal:
  //  - Shopify kann den BXGY-Rabatt nicht versehentlich einer vom Kunden selbst
  //    gekauften Flasche zuordnen, weil es nie dieselbe Variante ist.
  //  - Ein am Warenkorb haengengebliebener RIESLING49 kann nur noch dieses
  //    versteckte Produkt nullen. Ein normaler Kunde hat es nie im Warenkorb,
  //    der haengende Code kostet damit strukturell kein Geld mehr.
  //
  // Das Produkt muss 11,50 EUR kosten, nicht 0: die Preispruefung in
  // verifyOrGiveUp erkennt einen fehlgeschlagenen Rabatt daran, dass die
  // Position Geld kostet. Bei 0 EUR wuerde sie immer bestehen und der Shop
  // eine echte Flasche auch ohne wirksamen Rabatt verschenken.
  var GIFT_VARIANT_ID = 65970946801932;

  // Produktrabatt: ab 49 EUR eine Flasche gratis. Eine Nutzung pro Kunde,
  // kombinierbar mit Bestellrabatten (z. B. NEWS10 aus dem Newsletter-Link).
  var DISCOUNT_CODE = 'RIESLING49';

  var THRESHOLD_CENTS = 4900;
  var GATE_PARAM = 'nl_gift';
  // Die Position wird an GIFT_VARIANT_ID wiedererkannt. Die Property wird nur
  // gesetzt, damit cart-item.liquid die Sperre (feste Menge, kein Entfernen)
  // greifen lassen kann.
  var GIFT_PROPERTY = { _gift: 'nl49' };
  var GIFT_PROPERTY_KEY = Object.keys(GIFT_PROPERTY)[0];
  var GIFT_PROPERTY_VALUE = GIFT_PROPERTY[GIFT_PROPERTY_KEY];

  // Interne Einstellungen
  var STORAGE_KEY = 'korrell:nl_gift';
  // Merkt den Rabattcode, mit dem der Kunde eingestiegen ist (?discount=...),
  // damit er nach dem Zuruecknehmen von DISCOUNT_CODE wieder gesetzt werden kann.
  var ENTRY_DISCOUNT_KEY = 'korrell:nl_gift_entry_discount';
  var DEBOUNCE_MS = 250;

  // --- Hilfsfunktionen -----------------------------------------------------

  function storage(action, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(STORAGE_KEY);
      if (action === 'set') return window.localStorage.setItem(STORAGE_KEY, value);
      if (action === 'remove') return window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // Privater Modus oder blockierte Site-Daten: ohne Speicher gilt das Gate
      // nur fuer den aktuellen Seitenaufruf.
      return null;
    }
  }

  /**
   * Liest GATE_PARAM aus der URL und merkt das Ergebnis.
   * ?nl_gift=1 aktiviert, ?nl_gift=0 deaktiviert (zum Testen und Zuruecksetzen).
   */
  function syncGateFromUrl() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    if (!params.has(GATE_PARAM)) return;

    var raw = (params.get(GATE_PARAM) || '').toLowerCase();
    var off = raw === '0' || raw === 'false' || raw === 'no';

    if (off) {
      storage('remove');
      try { window.localStorage.removeItem(ENTRY_DISCOUNT_KEY); } catch (e) {}
      return;
    }

    storage('set', '1');

    // Einstiegs-Rabattcode merken (z. B. NEWS10 aus dem Newsletter-Link).
    var entry = params.get('discount');
    if (entry) {
      try { window.localStorage.setItem(ENTRY_DISCOUNT_KEY, entry); } catch (e) {}
    }

    // Und sofort anwenden. Der Query-Parameter allein bewirkt auf dieser
    // Storefront nichts - weder Cookie noch Rabatt, an der echten Storefront
    // gemessen. Ohne diesen Aufruf bekommt kein Newsletter-Besucher seine 10 %.
    applyEntryDiscount();
  }

  function isGateActive() {
    return storage('get') === '1';
  }

  /**
   * Erkennt die Gratis-Position an Variante UND Marker-Property.
   *
   * Das Geschenk ist seit dem dedizierten Produkt eine eigene, regulaer nicht
   * verkaufte Variante. Die Marker-Property bleibt als zweite Bedingung: nur
   * was dieses Skript selbst eingelegt hat, darf es auch auf Menge 1 zwingen
   * oder entfernen. Shopify legt Positionen mit unterschiedlichen Properties
   * getrennt ab, die Unterscheidung traegt also.
   */
  function isGiftLine(item) {
    if (!item) return false;
    var variantId = typeof item.variant_id !== 'undefined' ? item.variant_id : item.id;
    if (Number(variantId) !== Number(GIFT_VARIANT_ID)) return false;
    return !!(item.properties && item.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VALUE);
  }

  /**
   * Qualifizierender Betrag: Summe der Positionen OHNE Gift-Marker. Die
   * Gratis-Position zaehlt nie mit, sonst wuerde sie sich selbst ueber der
   * Schwelle halten.
   *
   * Basis ist original_line_price, der Preis VOR Rabatten - dieselbe Grundlage,
   * auf der Shopify die Mindestkaufsumme eines BXGY-Rabatts rechnet. An der
   * echten Storefront gemessen: bei 49,50 EUR mit aktivem NEWS10 steht
   * original_line_price auf 4950, line_price dagegen auf 4455. Ueber
   * line_price zu rechnen wuerde den Warenkorb faelschlich unter die Schwelle
   * druecken und dem Kunden die Flasche wieder wegnehmen.
   */
  function qualifyingTotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isGiftLine(item)) return sum;
      var price = typeof item.original_line_price === 'number'
        ? item.original_line_price
        : item.final_line_price;
      return sum + (price || 0);
    }, 0);
  }

  function giftLines(cart) {
    return (cart.items || []).filter(isGiftLine);
  }

  // --- Cart-Schreibzugriffe (ueber die Theme-Routen) ------------------------

  var disabled = false;

  function addGift() {
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: GIFT_PROPERTY
        }]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add.js: ' + response.status);
      return response.json();
    });
  }

  function removeLine(key) {
    return theme.cart.changeItem(key, 0);
  }

  /**
   * Loest das Neu-Rendern ueber den Theme-eigenen Weg aus. Darauf hoert jede
   * CartForm, also Drawer und Warenkorbseite gleichzeitig.
   */
  function rerenderCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  // --- Rabattcode ----------------------------------------------------------

  function readDiscountCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /**
   * Nimmt DISCOUNT_CODE zurueck, wenn die Gratisflasche geht.
   *
   * Ohne diesen Schritt bleibt der Code an der Session haengen und zieht bei
   * jedem Folgekauf 11,50 EUR von einer selbst gekauften Flasche ab - gemessen
   * an der echten Storefront. Zusammen mit dem nie ablaufenden Gate wird daraus
   * "ein Besucher, unbegrenzt viele Gratisflaschen".
   *
   * Nur loeschen, wenn im Cookie tatsaechlich unser Code steht: es haelt genau
   * einen Wert, und NEWS10 darf dem Kunden nicht genommen werden. Zur Sicherheit
   * wird der gemerkte Einstiegs-Code danach erneut gesetzt.
   */
  function releaseDiscount() {
    if (readDiscountCookie() !== DISCOUNT_CODE) return Promise.resolve();
    document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

    return applyEntryDiscount();
  }

  /**
   * Wendet den gemerkten Einstiegs-Code an (z. B. NEWS10).
   *
   * Nur die Pfad-Variante wirkt: der Query-Parameter discount=CODE aus dem
   * Newsletter-Link setzt hier weder Cookie noch Rabatt. Diese eine Funktion
   * bedient Einstieg, Geschenk-Pfad und Release, damit die drei nicht wieder
   * auseinanderlaufen.
   *
   * Ohne gemerkten Code passiert nichts: wer ohne discount=... kam, darf hier
   * weder einen Code bekommen noch einen verlieren.
   */
  function applyEntryDiscount() {
    var entry = null;
    try { entry = window.localStorage.getItem(ENTRY_DISCOUNT_KEY); } catch (e) {}
    if (!entry || entry === DISCOUNT_CODE) return Promise.resolve();

    return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(entry), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function () { /* Einstiegs-Code nicht wiederherstellbar, nicht kritisch */ });
  }

  /**
   * Setzt den Code ueber /discount/<CODE>. Der 302 liefert
   * "Set-Cookie: discount_code=...", das der Browser bei einem Same-Origin-Fetch
   * uebernimmt - ohne Navigation. Ein bereits am Warenkorb festgeschriebener
   * Code wie NEWS10 ueberlebt das, weil Shopify kombinierbare Codes dort
   * stapelt; ein nur im Cookie vorgemerkter Code wird dagegen ueberschrieben.
   */
  function applyDiscountViaFetch() {
    return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(DISCOUNT_CODE), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).then(function () { return null; });
  }

  /**
   * Prueft am Warenkorb, ob der Rabatt wirklich greift: die Gratis-Position muss
   * 0 kosten. Das Cookie allein ist kein Beweis - ein nicht existierender Code
   * wird genauso gesetzt.
   */
  function giftIsFree(cart) {
    var line = (cart.items || []).filter(isGiftLine)[0];
    return !!line && line.final_line_price === 0;
  }

  /**
   * Wendet den Rabatt an und stellt sicher, dass die Gratis-Position danach
   * wirklich 0 kostet. Reihenfolge: Fetch-Weg, sonst einmalig Navigation, sonst
   * Flasche zuruecknehmen und stilllegen - der Kunde soll nie eine bezahlte
   * Flasche bekommen, die er nicht bestellt hat.
   */
  function giveUp(cart) {
    disabled = true;
    var line = (cart.items || []).filter(isGiftLine)[0];
    console.error(
      '[newsletter-gift] Rabattcode ' + DISCOUNT_CODE + ' greift nicht - die Flasche ' +
      'kostet weiterhin Geld. Position wird zurueckgenommen. Bitte Code und ' +
      'Rabatt-Bedingungen im Shopify-Admin pruefen.'
    );
    // Auch im Fehlerfall den Code zuruecknehmen und den Einstiegs-Code
    // wiederherstellen. Sonst haengt RIESLING49 an der Session und hat NEWS10
    // im Cookie ueberschrieben - der Kunde verliert seinen Bestellrabatt wegen
    // eines Fehlers, den er nicht verursacht hat.
    var removed = line ? removeLine(line.key) : Promise.resolve(cart);
    return removed.then(function (res) {
      return releaseDiscount().then(function () { return res; });
    });
  }

  /**
   * Prueft, ob der Rabatt greift. Ist die Flasche nicht gratis, wird der Code
   * einmal erneut gesetzt und nachgeprueft - Shopify braucht die Zuordnung
   * gelegentlich einen Schreibzugriff spaeter. Bleibt sie bezahlt, wird
   * zurueckgenommen. Kein Reload.
   */
  function verifyOrGiveUp(cart) {
    if (giftIsFree(cart)) return Promise.resolve(cart);
    return applyDiscountViaFetch()
      .then(function () { return theme.cart.getCart(); })
      .then(function (secondTry) {
        return giftIsFree(secondTry) ? secondTry : giveUp(secondTry);
      });
  }

  /**
   * Setzt den Rabattcode und legt danach die Flasche ein. Diese Reihenfolge
   * sorgt dafuer, dass Shopify den Rabatt bereits beim Hinzufuegen zuordnet.
   */
  function addGiftWithDiscount() {
    return applyDiscountViaFetch()
      .then(addGift)
      .then(verifyOrGiveUp)
      .then(function (cart) {
        // RIESLING49 hat das Cookie uebernommen - es haelt genau einen Wert.
        // Stand NEWS10 dort erst als Vormerkung (Einstieg mit bereits
        // gefuelltem Warenkorb, also ohne Schreibzugriff, der ihn am Warenkorb
        // festschreibt), waere er jetzt verloren. Einmal nachsetzen kostet
        // einen Roundtrip und schliesst das.
        return applyEntryDiscount().then(function () { return cart; });
      });
  }

  // --- Kernlogik -----------------------------------------------------------

  var inFlight = false;
  var pending = false;
  var debounceTimer = null;

  /**
   * Fuehrt genau eine Schreiboperation aus. Waehrend sie laeuft, werden weitere
   * Bewertungen nicht verworfen, sondern als 'pending' vermerkt und danach
   * nachgeholt - sonst koennte bei schnellen Klicks die letzte Mengenaenderung
   * unbewertet bleiben.
   */
  function runWrite(write) {
    inFlight = true;
    return write()
      .then(function () {
        inFlight = false;
        rerenderCart();
        // Nach einer erfolgreichen Aenderung erneut bewerten: der Warenkorb kann
        // sich zwischenzeitlich weiter verschoben haben, und bei mehreren
        // Gift-Positionen sind mehrere Schritte noetig.
        evaluateDebounced();
      })
      .catch(function (e) {
        inFlight = false;
        // Bewusst KEINE erneute Bewertung: schlaegt das Schreiben fehl (z. B.
        // Flasche ausverkauft), wuerde ein Neuversuch sonst endlos laufen.
        // Der naechste echte Cart-Event bewertet ohnehin neu.
        pending = false;
        console.error('[newsletter-gift]', e);
      });
  }

  /**
   * Bewertet den Warenkorb und legt das Gratisprodukt rein oder raus.
   * @param {Object} [cart] Warenkorb-JSON, falls bereits vorhanden (z. B. aus
   *                        dem Payload von 'cart:updated') - sonst wird geladen.
   */
  function evaluate(cart) {
    if (!GIFT_VARIANT_ID || disabled) return Promise.resolve();   // Sicherheitsnetz
    if (inFlight) { pending = true; return Promise.resolve(); }

    var ready = cart && cart.items ? Promise.resolve(cart) : theme.cart.getCart();

    return ready.then(function (currentCart) {
      var lines = giftLines(currentCart);

      // Gate aus (z. B. ueber ?nl_gift=0): nichts Neues einlegen - aber eine
      // bereits liegende Gratisflasche muss raus. Bliebe sie liegen, zahlt der
      // Kunde ohne den Rabatt die vollen 11,50 EUR fuer eine Position, die als
      // Geschenk ausgewiesen ist.
      if (!isGateActive()) {
        if (!lines.length) return null;
        return runWrite(function () {
          return removeLine(lines[0].key).then(function (res) {
            return releaseDiscount().then(function () { return res; });
          });
        });
      }

      var qualifies = qualifyingTotal(currentCart) >= THRESHOLD_CENTS;

      // Genau eine Gift-Position mit Menge 1 ist der Soll-Zustand.
      if (qualifies && lines.length > 1) {
        return runWrite(function () { return removeLine(lines[lines.length - 1].key); });
      }
      if (qualifies && lines.length === 1 && lines[0].quantity !== 1) {
        return runWrite(function () { return theme.cart.changeItem(lines[0].key, 1); });
      }
      if (qualifies && lines.length === 0) {
        // Flasche einlegen, Code anwenden, danach pruefen ob sie wirklich
        // gratis ist. Erst diese Pruefung entscheidet, ob der Rabatt greift.
        return runWrite(addGiftWithDiscount);
      }
      if (!qualifies && lines.length > 0) {
        return runWrite(function () {
          return removeLine(lines[0].key).then(function (res) {
            return releaseDiscount().then(function () { return res; });
          });
        });
      }
      // Flasche liegt richtig drin, kostet aber Geld: Rabatt (erneut) anwenden.
      // Deckt den Zustand nach dem Reload-Fallback ab und den Fall, dass der
      // Code spaeter nicht mehr greift (z. B. Nutzungslimit erreicht).
      if (qualifies && lines.length === 1 && lines[0].final_line_price > 0) {
        return runWrite(function () { return verifyOrGiveUp(currentCart); });
      }

      return null;   // Soll-Zustand erreicht: nichts schreiben, kein Re-Render
    }).catch(function (e) {
      console.error('[newsletter-gift]', e);
    });
  }

  function evaluateDebounced(cart) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (inFlight) { pending = true; return; }
      if (pending) { pending = false; cart = null; }   // Payload ist veraltet
      evaluate(cart);
    }, DEBOUNCE_MS);
  }

  // --- Start ---------------------------------------------------------------

  function init() {
    syncGateFromUrl();

    // Mengenaenderungen und sonstige Cart-Updates liefern den Warenkorb direkt mit.
    document.addEventListener('cart:updated', function (evt) {
      evaluateDebounced(evt.detail && evt.detail.cart);
    });

    // Nach einem regulaeren Add-to-Cart neu bewerten.
    document.addEventListener('ajaxProduct:added', function () {
      evaluateDebounced();
    });

    // 'cart:updated' feuert nur bei Mengenaenderungen. Entfernt der Kunde eine
    // Position ueber das X im Drawer, laeuft das ueber deleteATC() in
    // snippets/cart-drawer.liquid, das nur 'cart:build' ausloest. Daher auch
    // hier mithoeren, sonst bliebe das Gratisprodukt liegen, wenn der Betrag
    // dadurch unter die Schwelle faellt.
    //
    // Keine Endlosschleife: evaluate() schreibt nur, wenn Soll und Ist
    // auseinanderlaufen, und loest 'cart:build' nur nach einer echten Aenderung
    // aus. Die selbst ausgeloeste Runde kostet eine Cart-Abfrage und endet dann.
    document.addEventListener('cart:build', function () {
      evaluateDebounced();
    });

    // Erstbewertung: deckt den Aufruf ueber den Newsletter-Link ab und den Fall,
    // dass der Warenkorb aus einer frueheren Sitzung schon qualifiziert.
    evaluateDebounced();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
